export default "__VITE_ASSET__C549z89___"